import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import * as Sentry from '@sentry/react';

const environment = process.env.NODE_ENV || 'development';
const release = process.env.REACT_APP_GIT_SHA;
Sentry.init({
  dsn: 'https://9e028a0cef934dca9d02e529166bb1c0@o4504570771210240.ingest.us.sentry.io/4504570775011331',
  environment: environment,
  release: release,
  enabled: environment === 'production',
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    // Disabled in favor of custom TriageModal
    // Sentry.feedbackIntegration({
    //   // Additional SDK configuration goes in here, for example:
    //   includeReplay: true,
    //   showBranding: false,
    //   colorScheme: 'system',
    //   showEmail: false,
    // }),
  ],

  // 1% of transactions — Axiom/OTel covers the rest.
  tracesSampleRate: 0.01,

  // Sample 100% of the spans we explicitly use for performance monitoring
  // (company search, PDF file load). Other transactions stay at the
  // global 1% rate so total Sentry transaction volume doesn't balloon.
  tracesSampler: samplingContext => {
    const op = samplingContext?.attributes?.['sentry.op'] || samplingContext?.transactionContext?.op;
    if (op === 'search.company' || op === 'file.load') return 1.0;
    if (typeof samplingContext?.parentSampled === 'boolean') return samplingContext.parentSampled;
    return 0.01;
  },

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: [
  //   /^\//,
  //   /^https:\/\/courcing\.bidequity\.ai\/graphql/
  // ],
  tracePropagationTargets: ['http://localhost:3000', /^https:\/\/cortex\.bid\.pe\//, /^https:\/\/ai\.bid\.pe\//],

  // Replay only on errors — skip normal sessions entirely.
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,

  beforeSend(event) {
    const exception = event.exception?.values?.[0];
    if (!exception) return event;

    const value = exception.value || '';
    const frames = exception.stacktrace?.frames || [];

    // Browser runtime noise; not actionable for product code changes.
    if (exception.type === 'ResizeObserverLoopError' || value.includes('ResizeObserver loop')) {
      return null;
    }

    const isFileManagerPathSplitCrash =
      exception.type === 'TypeError' &&
      value.includes("reading 'split'") &&
      frames.some(frame => frame?.filename?.includes('breadcrumb-bar'));

    if (isFileManagerPathSplitCrash) {
      event.fingerprint = ['syncfusion-filemanager-breadcrumb-path-split'];
      event.tags = {
        ...event.tags,
        ui_component: 'company-files-filemanager',
      };
    }

    return event;
  },
});
// Sentry.setUser({
//   fullName: user?.attributes?.name,
//   email: user?.attributes?.email,
// });

(function () {
  try {
    var e =
        typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
            ? global
            : typeof globalThis !== 'undefined'
              ? globalThis
              : {},
      n = new e.Error().stack;
    if (n) {
      e._sentryDebugIds = e._sentryDebugIds || {};
      e._sentryDebugIds[n] = 'd4e7db15-645c-5a05-995e-4a948459de0f';
    }
  } catch (e) {}
})();

//# debugId=d4e7db15-645c-5a05-995e-4a948459de0f
